import angular from 'angular';
import ServicesModule from '../../../services/services';
import ResourcesModule from '../../../resources/resources';
import template from './bidPricesEdit.jade';


import confirmationModalTemplate from './confirmationModal.jade';

export class BidPricesEditController {
  /* @ngInject */
  constructor(ManualMaxBidPrices, MaxBidPricesCampaignBestMatch, ModalService) {
    this.ModalService = ModalService;
    this.ManualMaxBidPrices = ManualMaxBidPrices;
    this.MaxBidPricesCampaignBestMatch = MaxBidPricesCampaignBestMatch;
    this.resource = {};
    this.currentMaxBidPrice;
    this.isExactMatch;
    this.apiError = false;
    this.cleanParamsOfLastSearch = {};
    this.idOfLastFetchedBidPrice;
    this.type = 'automatic';
  }

  searchBidPrice() {

    this.apiError = false;

    const cleanParams = this.doCleanParams(this.resource);

    this.MaxBidPricesCampaignBestMatch.one().get(cleanParams).then(res => {
      this.cleanParamsOfLastSearch = cleanParams;
      this.idOfLastFetchedBidPrice = res.id;
      this.currentMaxBidPrice = res.max_bid_price;
      this.jsonResponse = JSON.stringify(res.plain(), undefined, 4);
      this.detectExactMatch(res.plain(), cleanParams);
      this.type=res.type;
    }, (error) => {
      this.apiError = true;
      this.currentMaxBidPrice = 0;
      this.jsonResponse = '';
    });
  }

  detectExactMatch(plainResponse, cleanParams) {
    let definedDimensionsInResponse = this.doCleanParams(_.pick(plainResponse, [
      'campaign_id',
      'campaign_type',
      'country_code',
      'platform',
      'creative_id',
      'creative_dimensions',
      'creative_type',
      'channel',
      'publisher',
      'day_of_week',
      'hour_of_day',
      'nth_impression',
      'traffic_source',
      'gaming_bundle'
    ]));
    this.isExactMatch = _.isEqual(definedDimensionsInResponse, cleanParams);
  }

  doCleanParams(params) {
    _.forEach(params, (value, key) => { value === '' && delete params[key] });
    return _(params).omitBy(_.isUndefined).omitBy(_.isNull).value();
  }

  tryToPersistBidPrice() {
    const cleanParams = this.doCleanParams(this.cleanParamsOfLastSearch);
    const modalMsg = !cleanParams.campaign_id ?
      'Generic bid prices will take precedence over automatic bid prices! Try to avoid creating manual prices without a Campaign ID' :
      Object.keys(cleanParams).length < 3 ?
      'Generic bid prices will take precedence over automatic bid prices! Are you sure you want to continue?' :
      '';

    if(modalMsg) {
      this.ModalService.showModal({
        template: confirmationModalTemplate(),
        controllerAs: 'vm',
        controller: function(msg, close) {
          this.msg = msg;
          this.close = close;
        },
        inputs: {
          msg: modalMsg
        }
      }).then((modal) => {
        modal.close.then((res) => {
          res && this.persistBidPrice();
        });
      });
    } else {
      this.persistBidPrice();
    }
  }

  persistBidPrice() {
    const params = _.merge(this.cleanParamsOfLastSearch, {
      client_bid: false,
      max_bid_price: this.currentMaxBidPrice
    });
    if(this.isExactMatch && this.type == 'manual') {
      this.ManualMaxBidPrices.one(this.idOfLastFetchedBidPrice).customPUT(_.merge(params, {id: this.idOfLastFetchedBidPrice}));
    } else {
      this.ManualMaxBidPrices.post(params);
    }
  }

}

export function BidPricesEditComponent() {
  return {
    template,
    controller: BidPricesEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      title: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.bidPrices.edit', [
  'angularModalService',
  ServicesModule.name,
  ResourcesModule.name
])
.directive('bidPricesEdit', BidPricesEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/bidPrices/bidPricesEdit.js
 **/